// @flow

import React, { Component } from 'react'
import { containerIds } from 'redux/modules/ui'

export type FavoriteSelectModalUsecaseType = {
  initialize: Function,
  fetchFavoriteList: Function,
  openInputFavoriteName: Function,
  closeInputFavoriteName: Function,
  closeFavoriteList: Function,
  showModal: Function,
  inputFavoriteListName: Function,
  createFavoriteList: Function,
  addFavoriteToList: Function,
  removeFavoriteFromList: Function,
  setRegisteredFavoriteLists: Function,
}

const scrollLock = (e: Event) => {
  e.preventDefault()
}

export default (WrappedComponent: any) =>
  class FavoriteSelectModalUsecase extends Component<*> {
    /**
     * 初期処理
     */
    initialize = () => {
      this.fetchFavoriteList()
      this.showModal()

      const { data } = this.props
      data.refetch()
    }

    /**
     * 時間差でモーダル表示フラグをONにする
     */
    showModal = () => {
      setTimeout(() => {
        const { actions } = this.props
        if (document && document.body && document.body.style) {
          document.body.style.overflow = 'hidden'
          document.body.addEventListener('touchmove', scrollLock, false)
        }
        actions.setUIState(containerIds.ROOM, {
          isShowingFavoriteSelectModal: true,
        })
      }, 200)
    }

    /**
     * お気に入りリスト取得
     */
    fetchFavoriteList = () => {
      const { actions, currentUser } = this.props
      actions.fetchFavoriteList({ userId: currentUser.id })
    }

    /**
     * 新規お気に入りリスト名入力フィールドを開く
     */
    openInputFavoriteName = (e: Event) => {
      e.preventDefault()
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, { openInputFavoriteName: true })
    }

    /**
     * 新規お気に入りリスト名入力フィールドを閉じる
     */
    closeInputFavoriteName = (e: Event) => {
      e.preventDefault()
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, {
        openInputFavoriteName: false,
        inputFavoriteListName: '',
      })
    }

    /**
     * お気に入りリスト非表示
     */
    closeFavoriteList = (e: Event) => {
      e.preventDefault()
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, {
        isShowingFavoriteSelectModal: false,
      })
      setTimeout(() => {
        if (document && document.body && document.body.style) {
          document.body.style.overflow = 'auto'
          document.body.removeEventListener('touchmove', scrollLock, false)
        }
        actions.setUIState(containerIds.ROOM, {
          isOpenFavoriteSelectModal: false,
        })
      }, 200)
    }

    /**
     * お気に入りリストの名前入力
     */
    inputFavoriteListName = (e: SyntheticInputEvent<*>) => {
      const { actions } = this.props
      actions.setUIState(containerIds.ROOM, {
        inputFavoriteListName: e.target.value,
      })
    }

    /**
     * お気に入りリストの作成
     */
    createFavoriteList = (e: Event, roomId: string) => {
      e.preventDefault()
      const { actions, currentUser, ui } = this.props
      actions.createFavoriteList({
        userId: currentUser.id,
        roomId,
        name: ui.inputFavoriteListName,
      })
    }

    /**
     * スペースをお気に入りに追加
     */
    addFavoriteToList = (roomId: string, favoriteListId: string) => {
      const { actions, currentUser } = this.props
      actions.addFavorite({
        userId: currentUser.id,
        roomId,
        favoriteListId,
      })
    }

    /**
     * スペースのお気に入りを解除
     */
    removeFavoriteFromList = (roomId: string, favoriteListId: string) => {
      const { actions, currentUser } = this.props
      actions.removeFavorite({
        userId: currentUser.id,
        roomId,
        favoriteListId,
      })
    }

    /**
     * 登録済みお気に入りリストを設定
     */
    setRegisteredFavoriteLists = (lists: Array<any>) => {
      const { actions } = this.props
      actions.setRegisteredFavoriteLists(lists)
    }

    render() {
      return <WrappedComponent {...this.props} usecase={this} />
    }
  }



// WEBPACK FOOTER //
// ./src/containers/organisms/FavoriteSelectModal/usecase.jsx